
import Vue from "vue";
import TopBar from "@/components/navigation/TopBar.vue";
import { AuthService } from "@/services";

export default Vue.extend({
  components: {
    TopBar,
  },
  data() {
    return {
      code: "",
      state: "",
      errorMessage: "",
      loading: false,
    };
  },
  watch: {
    $route(value) {
      this.errorMessage = (value.query.error as string) || "";
    },
  },
  beforeMount() {
    this.code = this.$route.query.code as string;
    this.state = this.$route.query.state as string;
    this.errorMessage = (this.$route.query.error as string) || "";
    if (this.code && this.state) this.generateToken();
  },
  methods: {
    async initiateLogin() {
      try {
        this.errorMessage = "";
        this.loading = true;
        const { data } = await AuthService.getAuthorizationUrl();
        window.location.href = data.url;
      } catch (error: any) {
        this.errorMessage = error?.response?.message || error.message;
      }
    },
    async generateToken() {
      try {
        this.loading = true;
        await this.$store.dispatch("auth/generateToken", {
          code: this.code,
          state: this.state,
        });
        this.$router.push({ name: "homepage" }).catch(() => {});
      } catch (error: any) {
        this.errorMessage = error?.response?.message || error.message;
      }
    },
  },
});
